import { ColorPalette } from 'shared/consts/colorPalette';
import { RegionSource } from 'components/file-editor-components/file-viewer/region-types';
import { AnnotationApi } from 'components/file-editor-components/file-viewer/types';

export const REGION_APPEARANCE = { strokeWidth: 1, opacity: 1 };
export const SELECTED_REGION_APPEARANCE = { strokeWidth: 3, opacity: 0.65 };

export const REGION_FILL_COLOR = 'none';

export const regionStrokeColor = (source: RegionSource) =>
	source === 'server' ? ColorPalette.royalBlue : ColorPalette.violetRed;

export const applyRegionAppearance = (annotation: AnnotationApi, sourceId: string, isSelected: boolean) => {
	const tracked = annotation.getAnnotations().find((item) => item.object.custom?.sourceId === sourceId);
	if (!tracked) return;

	const { strokeWidth, opacity } = isSelected ? SELECTED_REGION_APPEARANCE : REGION_APPEARANCE;
	const source = (tracked.object.custom?.source as RegionSource) || 'user';
	annotation.updateAnnotation(tracked.object.pageIndex, tracked.object.id, {
		strokeWidth,
		strokeColor: regionStrokeColor(source),
		opacity,
	});
	annotation.invalidatePageAppearances(tracked.object.pageIndex);
};
